/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Pagination from 'components/atoms/pagination';
import Loader from 'components/atoms/loader';
import { linkDaLicitacao } from 'services/market_links';

interface BiddingListConcurrentsProps {
  currentPageBidding: number;
  setCurrentPageBidding: React.Dispatch<React.SetStateAction<number>>;
}

const BiddingListConcurrents = (props: BiddingListConcurrentsProps) => {
  const { currentPageBidding, setCurrentPageBidding } = props;
  const { company, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPageBidding(currentPage);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <ul className="table-responsive" style={{ maxHeight: '400px' }}>
          {request?.get_provider_biddings?.loading ? (
            <Loader />
          ) : (
            <table className="table table-bordered">
              <thead style={{ backgroundColor: '#EBECEF' }}>
                <tr>
                  <th scope="col">N.º CNL</th>
                  <th scope="col">Item</th>
                  <th scope="col"> Qnt.</th>
                  <th scope="col">Valor un.</th>
                  <th scope="col">Valor total</th>
                </tr>
              </thead>
              <tbody>
                {company?.biddings?.map((bidding) => (
                  <tr key={bidding?._source?.licitacao_id}>
                    <td>
                      <a
                        href={linkDaLicitacao(bidding?._source?.licitacao_id)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {bidding?._source?.licitacao_id}
                      </a>
                    </td>

                    <td>{bidding?._source?.item_descricao}</td>
                    <td>{bidding?._source?.item_quantidade}</td>
                    <td>
                      {bidding?._source?.item_valor_unitario?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                    <td>
                      {bidding?._source?.item_valor_total?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                  </tr>
                ))}
                {company?.biddings?.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center border-0 pb-0">
                      <div className="alert alert-secondary m-0" role="alert">
                        <h4 className="alert-heading">Resultado não encontrado.</h4>
                        <p className="mb-0">
                          Não foram encontradas informações relacionadas a este CNPJ.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </ul>
        <div className="row d-print-none">
          <div className="col-md-12 px-4 mb-1">
            <Pagination
              postsPerPage={5}
              totalPosts={company?.total_result}
              paginate={paginate}
              currentPage={currentPageBidding}
              firstAndLastPage
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingListConcurrents;
